module.exports = __webpack_public_path__ + "img/phone2.991b9668.png";